import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.nav `
  --fgColor: ${brand.white};
  --bgColor: ${brand.green};

  position: fixed;
  top: var(--headerHeight);
  left: 0;
  display: flex;
  flex-direction: column;
  background: var(--bgColor);
  color: var(--fgColor);
  height: calc(100% - var(--headerHeight, 0px) - var(--mobileCtaHeight, 0px));
  opacity: 0;
  overflow-y: auto;
  padding: 0;
  pointer-events: none;
  ${transition('opacity')};
  width: 100%;
  z-index: ${Layers.Header};

  &[data-m-active='true'] {
    opacity: 1;
    pointer-events: all;
  }

  &[data-scroll-active='true'] {
    top: var(--headerScrollHeight);
    height: calc(100% - var(--headerScrollHeight, 0px) - var(--mobileCtaHeight, 0px));
  }

  &[data-is-level='true'] {
    background-color: ${brand.white};
  }

  @media ${from(Device.Tablet)} {
    height: calc(100% - var(--headerHeight, 0px) - var(--floatingCtaHeight, 0px));

    &[data-scroll-active='true'] {
      height: calc(100% - var(--headerScrollHeight, 0px) - var(--floatingCtaHeight, 0px));
    }
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const List = styled.ul `
  padding: 0 0 32px;

  &[data-active-link='true'] {
    padding: 0;
  }
`;
const Item = styled.li `
  margin-top: 8px;
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.brandonGrotesque.medium};
  font-size: 20px;
  line-height: 1em;
  padding: 16px 18px;
  text-decoration: none;
  background-color: ${rgba(brand.white, 0.125)};

  &:focus,
  &:hover {
    color: ${brand.white};
    text-decoration: underline;
    text-underline-position: under;
  }

  ${Container}[data-is-level='true'] & {
    background-color: ${brand.beige};
    color: ${brand.black};
  }
`;
const Text = styled.span ``;
const Arrow = styled.span `
  height: 20px;
  margin-left: auto;
  width: 11px;
`;
const Header = styled.div `
  padding: 0;
  background-color: ${brand.green};
`;
const Back = styled.button `
  ${fonts.brandonGrotesque.medium};

  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${brand.white};
  font-size: 20px;
  line-height: 1em;
  margin: 0;
  padding: 18px;
  text-decoration: none;
  gap: 18px;
  width: 100%;

  > svg {
    height: 20px;
    transform: rotate(180deg);
    width: 11px;
  }
`;
const Telephone = styled(Link) `
  text-decoration: underline;
  text-underline-position: under;

  svg {
    display: inline-block;
    height: 22px;
    margin-right: 8px;
    width: 22px;
  }
`;
const Divider = styled.hr `
  display: block;
  border: 0;
  border-bottom: 1px solid ${brand.white};
  margin: 0;
  width: 100%;
`;
const QuickLinkList = styled.div `
  display: flex;
  gap: 24px 16px;
  padding: 32px 18px;
  flex-wrap: wrap;
`;
const QuickLink = styled.a `
  display: inline-flex;
  color: currentColor;
  flex: 1 1 calc(50% - 8px);
  ${fonts.brandonGrotesque.bold}
  font-size: 20px;
  line-height: 1em;
  place-content: flex-start;
  place-items: flex-start;
  text-decoration: none;
`;
const QuickLinkIcon = styled.span `
  display: inline-block;
  height: 20px;
  margin-right: 8px;
  width: 20px;
  flex-shrink: 0;
`;
const FeaturedCardsContainer = styled.div `
  display: grid;
  gap: 16px 8px;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 16px;
  padding: 16px;
  border-bottom: 1px solid ${brand.beige};
`;
const NavigationMobileStyles = {
    Arrow,
    Back,
    Container,
    Divider,
    FeaturedCardsContainer,
    Header,
    Item,
    Link,
    List,
    QuickLink,
    QuickLinkIcon,
    QuickLinkList,
    Telephone,
    Text,
};
export default NavigationMobileStyles;
